<div class="recovery">
  <div class="container">
    <div class="d-flex justify-content-center pt-5">
      <div class="col-5 p-4">
        <img
          class="logo mx-auto d-block pb-5"
          src="assets/images/logo-white.png" />
        <div class="recovery-div text-center">
          <form
            [formGroup]="form"
            role="form"
            autocomplete="off"
            novalidate>
            <fieldset [disabled]="loading">
              <div class="input-group mb-3">
                <span class="input-group-text">
                  <img src="assets/icons/mdi_lock-outline.svg" />
                </span>
                <div class="form-floating">
                  <input
                    [type]="showNewPassword ? 'text' : 'password'"
                    class="form-control bg-transparent border-0"
                    formControlName="password"
                    placeholder="{{ 'common.password' | translate }}"
                    autocomplete="new-password" />
                  <label
                    for="password"
                    class="form-label bg-transparent">
                    {{ 'common.password' | translate }}
                  </label>
                </div>
                <span class="input-group-text">
                  <app-button
                    classes="text-primary"
                    (clicked)="onShowPassword()">
                    <img [src]="!showNewPassword ? 'assets/icons/mdi_eye.svg' : 'assets/icons/mdi_eye-off.svg'" />
                  </app-button>
                </span>
              </div>
              <div class="validator-text">
                <small
                  *ngIf="
                    form.get('password')?.hasError('pattern') ||
                    form.get('password')?.hasError('minlength') ||
                    form.get('password')?.hasError('maxLength')
                  ">
                  {{ 'common.passwordFormat' | translate }}
                </small>
              </div>
              <div class="input-group mb-3">
                <span class="input-group-text">
                  <img src="assets/icons/mdi_lock-outline.svg" />
                </span>
                <div class="form-floating">
                  <input
                    [type]="showConfirmNewPassword ? 'text' : 'password'"
                    class="form-control bg-transparent border-0"
                    [class.ng-invalid]="form.hasError('unmatchedFields') || form.get('confirmPassword')?.hasError('required')"
                    formControlName="confirmPassword"
                    placeholder="{{ 'common.confirmNewPassword' | translate }}"
                    autocomplete="new-password" />
                  <label
                    for="confirmPassword"
                    class="form-label bg-transparent">
                    {{ 'common.confirmNewPassword' | translate }}
                  </label>
                </div>
                <span class="input-group-text">
                  <app-button
                    classes="text-primary"
                    (clicked)="onShowConfirmNewPassword()">
                    <img
                      [src]="!showConfirmNewPassword ? 'assets/icons/mdi_eye.svg' : 'assets/icons/mdi_eye-off.svg'" />
                  </app-button>
                </span>
              </div>
              <div
                *ngIf="form?.hasError('unmatchedFields')"
                class="validator-text d-flex">
                <small class="me-1">
                  {{ 'common.unmatchedPasswords' | translate }}
                </small>
              </div>
            </fieldset>
          </form>
          <app-button
            classes="mt-2 w-100 btn-primary btn-spinner-light"
            [showSpinner]="loading"
            [disabled]="form.invalid"
            (clicked)="resetPassword()">
            {{ 'login.recoverPassword' | translate }}
          </app-button>
          <div class="pt-3">
            <a
              class="link-secondary"
              (click)="backToLogin()">
              {{ 'login.backToLogin' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>